import React from 'react';
import { RefreshCcw, FileText } from 'lucide-react';

interface DGRHeaderProps {
  siteName: string;
  onRefresh: () => void;
  isRefreshing?: boolean;
}

const UploadHeader: React.FC<DGRHeaderProps> = ({ siteName, onRefresh, isRefreshing }) => {
  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-[#0084CF] rounded-lg">
              <FileText size={16} className="text-white" />
            </div>
            <h1 className="text-base text-gray-900" style={{ fontWeight: 400 }}>
              {siteName} Data Management
            </h1>
          </div>
          <button
            onClick={onRefresh}
            disabled={isRefreshing}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 bg-white hover:bg-gray-50 border border-gray-300 rounded-md transition-all duration-200 text-xs font-medium text-gray-700 ${isRefreshing ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            <RefreshCcw size={12} className={isRefreshing ? "animate-spin" : ""} />
            <span>{isRefreshing ? "Refreshing..." : "Refresh"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadHeader;
